class ProductService {
    constructor(){
      this.baseUrl = window.Shopify?.routes?.root || '/';
    }

    static instance = null;

    static getInstance() {
        if (!ProductService.instance) {
            ProductService.instance = new ProductService();
        }
        return ProductService.instance;
    }

    async getProduct(handle) {
        try {
            const response = await fetch(`${this.baseUrl}products/${handle}.js`);
            console.log('response', response)
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const product = await response.json();
            return product;
        } catch (e) {
            console.warn(`Failed to fetch product ${handle}:`, e);
            return null;
        }
    }

    async getVariant(id) {
        try {
            const response = await fetch(`${this.baseUrl}variants/${id}.js`);
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const variant = await response.json();
            return variant;
        } catch (e) {
            console.warn(`Failed to fetch variant ${id}:`, e);
            return null;
        }
    }
}